// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".contract-card[data-v-4184b21a]{max-width:800px}", ""]);
// Exports
module.exports = exports;
